// Depends
import { route, group, subGroup, meta } from '@/helpers/routes'

import Create from './form/form'
import Index from './index/index'

const bikeRoutes = [
  route('create', '/create', Create, meta('Adicionar nova Bicicleta', true, 'guest')),
  route('edit', '/:id/edit', Create, meta('Editar Bicicleta', true, 'guest')),
  route('index', '/index', Index, meta('Lista de Bicicleta', true, 'guest'))
]

export default [
  ...group('/app', [
    ...subGroup('/bike', bikeRoutes)
  ])
]



// WEBPACK FOOTER //
// ./src/app/dweller/bike/routes.js